import { NotificationInterface, NotificationTemplateInterface } from '../models';

export interface NotificationStateInterface {
  ids?: number[];
  notifications?: { [id: number ]: NotificationInterface };
  selectedNotification?: number;
  notificationTemplates?: NotificationTemplateInterface[];
  selectedTemplate?: NotificationTemplateInterface;
  sendResults?: number;
}

export class NotificationState implements NotificationStateInterface {
  public ids?: number[];
  public notifications?: { [id: number ]: NotificationInterface };
  public selectedNotification?: number | null;
  public notificationTemplates?: NotificationTemplateInterface[];
  public selectedTemplate?: NotificationTemplateInterface;
  public sendResults?: number;
  constructor({
    ids = undefined,
    notifications = undefined,
    selectedNotification = undefined,
    notificationTemplates = undefined,
    selectedTemplate = undefined,
    sendResults = undefined,
    }: NotificationStateInterface) {
    this.ids = ids;
    this.notifications = notifications;
    this.selectedNotification = selectedNotification;
    this.notificationTemplates = notificationTemplates;
    this.selectedTemplate = selectedTemplate;
    this.sendResults = sendResults;
  }
}
